import React, { useState } from "react";
import {
	  Box,
	  Button,
	  Paper,
	  TextField,
	  Typography,
	  Container
} from "@mui/material";

const Login = ({ onLogin }) => {
	  const [username, setUsername] = useState("");
	  const [password, setPassword] = useState("");

	  const handleSubmit = () => {
		      onLogin(username, password);
		    };

	  return (
		      <Container maxWidth="sm">
		        <Box
		          display="flex"
		          justifyContent="center"
		          alignItems="center"
		          minHeight="100vh"
		        >
		          <Paper elevation={4} sx={{ p: 4, width: "100%" }}>
		            <Typography variant="h5" gutterBottom align="center">
		              Welcome to the Dementia Caregiver Training Simulation 👋
		            </Typography>
		            <Typography variant="body1" align="center" gutterBottom>
		              We're glad you're here. Please log in to continue.
		            </Typography>
		            <Box component="form" noValidate autoComplete="off" mt={3}>
		              <TextField
		                fullWidth
		                label="Username"
		                variant="outlined"
		                margin="normal"
		                value={username}
		                onChange={(e) => setUsername(e.target.value)}
		              />
		              <TextField
		                fullWidth
		                type="password"
		                label="Password"
		                variant="outlined"
		                margin="normal"
		                value={password}
		                onChange={(e) => setPassword(e.target.value)}
		              />
		              <Button
		                fullWidth
		                variant="contained"
		                color="primary"
		                sx={{ mt: 3 }}
		                onClick={handleSubmit}
		              >
		                Let's Go!
		              </Button>
		            </Box>
		          </Paper>
		        </Box>
		      </Container>
		    );
};

export default Login;

